import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IVDMDashboardContent } from "redux/app/vdmdashboard/@types";
import { IStore } from "redux/store";

interface IWeatherReportingRow {
	id: string;
	dateTime: string;
	typeOfReport: string;
	// type: "Forecast" | "Synopsis" | string;
	lowPressure1: { name: string; value: string; distance: string };
	lowPressure2: { name: string; value: string; distance: string };
	wind: { direction: string; speed: string };
	seaWave: { direction: string; height: string };
	swell: { direction: string; height: string };
	dangerPhenomenon: string;
	bvsCaptured: string;
}

const ReportTypeTag: React.FC<{ type: "Forecast" | "Synopsis" | string }> = ({
	type,
}) => {
	const isForecast = type === "Forecast";
	const bgColor = isForecast ? "bg-orange-100" : "bg-green-100";
	const textColor = isForecast ? "text-orange-600" : "text-green-600";
	const text = isForecast ? "Forecast" : type === "Synopsis" ? "Synopsis" : "";

	return (
		<span
			className={`px-3 py-1 text-xs font-medium rounded-md ${bgColor} ${textColor}`}
		>
			{text}
		</span>
	);
};

const GreenDot: React.FC = () => (
	<span className="text-green-500 mr-2.5 w-1.5 h-1.5 rounded-full" />
);

const weatherReportingData: IWeatherReportingRow[] = [
	{
		id: "1",
		dateTime: "29 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "26 KT" },
		seaWave: { direction: "SSW", height: "3.6 m" },
		swell: { direction: "SSW", height: "3.6 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "2",
		dateTime: "28 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "29 KT" },
		seaWave: { direction: "SSW", height: "4.7 m" },
		swell: { direction: "SSW", height: "4.7 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "3",
		dateTime: "27 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "25 KT" },
		seaWave: { direction: "SSW", height: "4.7 m" },
		swell: { direction: "SSW", height: "4.7 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "4",
		dateTime: "26 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "21 KT" },
		seaWave: { direction: "SSW", height: "4.7 m" },
		swell: { direction: "SSW", height: "4.7 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "5",
		dateTime: "25 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "17 KT" },
		seaWave: { direction: "SSW", height: "3.6 m" },
		swell: { direction: "SSW", height: "3.6 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "6",
		dateTime: "24 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "16 KT" },
		seaWave: { direction: "SSW", height: "4.7 m" },
		swell: { direction: "SSW", height: "4.7 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "7",
		dateTime: "23 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "15 KT" },
		seaWave: { direction: "SSW", height: "3.6 m" },
		swell: { direction: "SSW", height: "3.6 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
	{
		id: "8",
		dateTime: "22 May 2025 9:00 PM",
		typeOfReport: "-",
		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
		wind: { direction: "SSW", speed: "12 KT" },
		seaWave: { direction: "SSW", height: "3.6 m" },
		swell: { direction: "SSW", height: "3.6 m" },
		dangerPhenomenon: "-",
		bvsCaptured: "-",
	},
];

/* INFO: Not part of phase-1 */
// [
// 	{
// 		id: "1",
// 		dateTime: "29 May 2025 9:00 PM",
// 		type: "Forecast",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "26 KT" },
// 		seaWave: { direction: "SSW", height: "3.6 m" },
// 		swell: { direction: "SSW", height: "3.6 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "2",
// 		dateTime: "28 May 2025 9:00 PM",
// 		type: "Forecast",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "29 KT" },
// 		seaWave: { direction: "SSW", height: "4.7 m" },
// 		swell: { direction: "SSW", height: "4.7 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "3",
// 		dateTime: "27 May 2025 9:00 PM",
// 		type: "Forecast",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "25 KT" },
// 		seaWave: { direction: "SSW", height: "4.7 m" },
// 		swell: { direction: "SSW", height: "4.7 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "4",
// 		dateTime: "26 May 2025 9:00 PM",
// 		type: "Forecast",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "21 KT" },
// 		seaWave: { direction: "SSW", height: "4.7 m" },
// 		swell: { direction: "SSW", height: "4.7 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "5",
// 		dateTime: "25 May 2025 9:00 PM",
// 		type: "Forecast",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "17 KT" },
// 		seaWave: { direction: "SSW", height: "3.6 m" },
// 		swell: { direction: "SSW", height: "3.6 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "6",
// 		dateTime: "24 May 2025 9:00 PM",
// 		type: "Synopsis",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "16 KT" },
// 		seaWave: { direction: "SSW", height: "4.7 m" },
// 		swell: { direction: "SSW", height: "4.7 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "7",
// 		dateTime: "23 May 2025 9:00 PM",
// 		type: "Synopsis",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "15 KT" },
// 		seaWave: { direction: "SSW", height: "3.6 m" },
// 		swell: { direction: "SSW", height: "3.6 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// 	{
// 		id: "8",
// 		dateTime: "22 May 2025 9:00 PM",
// 		type: "Synopsis",
// 		lowPressure1: { name: "NA", value: "NA", distance: "NA" },
// 		lowPressure2: { name: "NA", value: "NA", distance: "NA" },
// 		wind: { direction: "SSW", speed: "12 KT" },
// 		seaWave: { direction: "SSW", height: "3.6 m" },
// 		swell: { direction: "SSW", height: "3.6 m" },
// 		dangerPhenomenon: "None",
// 		bvsCaptured: "Yes",
// 	},
// ]

const formatDate = (isoString: string): string => {
	if (!isoString) return "";
	const date = new Date(isoString);

	let hour = date.getUTCHours();
	const minute = date.getUTCMinutes().toString().padStart(2, "0");

	const ampm = hour >= 12 ? "PM" : "AM";
	hour = hour % 12;
	hour = hour ? hour : 12; // the hour '0' should be '12'

	return `${date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })} ${hour}:${minute} ${ampm}`;
};

type OwnProps = {
	weatherData?: IVDMDashboardContent["weatherData"];
};
type WeatherReportingTableProps = PropsFromRedux & OwnProps;
function WeatherReportingTable(props: WeatherReportingTableProps) {
	const { weatherData } = props;
	let parsedData: IWeatherReportingRow[] = [];

	if (weatherData && Array.isArray(weatherData)) {
		parsedData = weatherData.map((item, index) => ({
			id: item.sourceReportId?.toString() || `temp-${index}`,
			dateTime: formatDate(item.dateTimeUtc),
			typeOfReport: item.typeOfReport as any,
			lowPressure1: item.firstLowPressureTrsHurricane,
			lowPressure2: item.secondLowPressureTrsHurricane,
			wind: item.wind,
			seaWave: item.seaWave,
			swell: item.swell,
			dangerPhenomenon: item.checkBvsSnapshotDangerousPhenomenon || "-",
			bvsCaptured: item.bvsScreenshotCapturedAndShared || "-",
		}));
	}

	// TODO: No weather data fallback
	if (!parsedData || parsedData.length === 0) {
		return (
			<div className="w-full overflow-x-auto ws-scroll mt-4 border rounded-md flex items-center justify-center p-8 text-gray-500 bg-gray-50 h-40">
				No weather reporting data available.
			</div>
		);
	}

	//TODO: Process the weatherData to

	return (
		<div className="w-full overflow-x-auto ws-scroll mt-4 border rounded-md">
			<table className="w-full">
				<thead className="text-xs text-gray-500 uppercase bg-gray-50/50">
					<tr>
						<th
							scope="col"
							rowSpan={2}
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "180px" }}
						>
							Date / Time UTC
						</th>
						<th
							scope="col"
							rowSpan={2}
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "150px" }}
						>
							Type of report
						</th>
						<th
							scope="col"
							colSpan={3}
							className="px-6 py-3 text-center border-b border-r"
						>
							1st <br /> Low Pressure / TRS / Hurricane
						</th>
						<th
							scope="col"
							colSpan={3}
							className="px-6 py-3 text-center border-b border-r"
						>
							2nd <br /> Low Pressure / TRS / Hurricane
						</th>
						<th
							scope="col"
							colSpan={2}
							className="px-6 py-3 text-center border-b border-r"
						>
							Wind
						</th>
						<th
							scope="col"
							colSpan={2}
							className="px-6 py-3 text-center border-b border-r"
						>
							Sea wave
						</th>
						<th
							scope="col"
							colSpan={2}
							className="px-6 py-3 text-center border-b border-r"
						>
							Swell
						</th>
						<th
							scope="col"
							rowSpan={2}
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "280px" }}
						>
							Check BVS - Snap Shot. <br /> Will your vessel <br /> experience
							any dangerous <br /> phenomenon?
						</th>
						<th
							scope="col"
							rowSpan={2}
							className="px-6 py-3 border-b"
							style={{ minWidth: "280px" }}
						>
							BVS Screenshot Captured <br /> and shared (with this <br />{" "}
							report) for each latest <br /> Synopsis & all Forecast?
						</th>
					</tr>
					<tr>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Name
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Value
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Distance
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Name
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Value
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "80px" }}
						>
							Distance
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Direction
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Speed
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Direction
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Height
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Direction
						</th>
						<th
							scope="col"
							className="px-6 py-3 border-b border-r"
							style={{ minWidth: "90px" }}
						>
							Height
						</th>
					</tr>
				</thead>
				<tbody>
					{parsedData?.map((row) => {
						return (
							<tr className="bg-white border-b hover:bg-gray-50 text-sm text-gray-700">
								<td className="px-6 py-2.5 font-medium whitespace-nowrap border-r">
									{row.dateTime}
								</td>
								<td className="px-6 py-2.5 border-r flex justify-center">
									{row.typeOfReport}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure1.name}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure1.value}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure1.distance}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure2.name}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure2.value}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.lowPressure2.distance}
								</td>
								<td className="px-6 py-2.5 border-r">{row?.wind?.direction}</td>
								<td className="px-6 py-2.5 border-r whitespace-nowrap">
									<GreenDot />
									{row?.wind?.speed}
								</td>
								<td className="px-6 py-2.5 border-r">
									{row.seaWave.direction}
								</td>
								<td className="px-6 py-2.5 border-r whitespace-nowrap">
									<GreenDot />
									{row.seaWave.height}
								</td>
								<td className="px-6 py-2.5 border-r">{row.swell.direction}</td>
								<td className="px-6 py-2.5 border-r whitespace-nowrap">
									<GreenDot />
									{row.swell.height}
								</td>
								<td className="px-6 py-2.5 border-r">{row.dangerPhenomenon}</td>
								<td className="px-6 py-2.5">{row.bvsCaptured}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(WeatherReportingTable);
